<template>
    <section class="company-intro" id="company-intro">
        <div class="container">
            <div class="history">
                <div class="title-group" v-intersect>
                    <h2 class="sub-title text-primary-ci">회사 소개</h2>
                    <h3 class="text-xl text-primary-ci">솔닥은 의료의 디지털<br> 전환을 선도합니다</h3>
                </div>
                <div class="history-list" v-intersect>
                    <ul>
                        <li>
                            <strong>한국경제 주관<br> 소비자만족대상 수상</strong>
                            <span class="date">2024.04</span>
                        </li>
                        <li>
                            <strong>솔닥, 중소벤처기업부<br> 장관상 수상</strong>
                            <span class="date">2023.12</span>
                        </li>
                        <li>
                            <strong>솔닥, 보건복지부<br> 장관상 수상</strong>
                            <span class="date">2023.07</span>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <strong>서울 부산시 주관<br> 우수 스타트업 선정</strong>
                            <span class="date">2022.11</span>
                        </li>
                        <li>
                            <strong>원격진료 처방 및 의약품<br> 배송 관련 기술 특허 등록</strong>
                            <span class="date">2022.10</span>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <strong>비대면진료를 이용한 환자<br> 서비스 관련 기술 특허 등록</strong>
                            <span class="date">2022.10</span>
                        </li>
                        <li>
                            <strong>업계 최초 ESG 경영<br> 적합 판정</strong>
                            <span class="date">2022.09</span>
                        </li>
                        <li>
                            <strong>연세대학교와 헬스케어<br> AI분석 공동 특허 등록</strong>
                            <span class="date">2021.12</span>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <strong>비대면진료를 위한<br> 인공지능 기반 기술 특허 등록</strong>
                            <span class="date">2021.12</span>
                        </li>
                        <li>
                            <strong>보건복지부 비대면진료<br> 특화 사업체 선정</strong>
                            <span class="date">2021.06</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="products">
                <div class="title-group" v-intersect>
                    <h3 class="text-xl">누구에게나 쉽고 편한<br> 의료 환경을 만듭니다</h3>
                    <p class="desc">의료서비스가 필요한 모든 상황,<br> 솔닥의 디지털 헬스케어 솔루션이 함께합니다.</p>
                </div>
                <ul class="product-list" v-intersect>
                    <li>
                        <div class="tags">
                            <span>진료예약</span>
                            <span>자동결제</span>
                            <span>서류발급</span>
                        </div>
                        <strong class="product-name">바로솔닥</strong>
                        <p>병원 찾기부터 병원 예약, 결제와<br> 서류 발급까지 바로솔닥 앱 하나로<br> 간편하게 해결하세요</p>
                        <a href="https://soldoc.co.kr/" class="more" target="_blank" title="새 창">자세히 보기</a>
                    </li>
                    <li>
                        <div class="tags">
                            <span>시니어케어</span>
                            <span>비대면진료</span>
                        </div>
                        <strong class="product-name">바로돌봄</strong>
                        <p>장기요양기관, 경로당, 실버타운, 장애인시설 등에서 도입하여 이용할 수 있는 원격진료 솔루션입니다.</p>
                        <a href="#header" class="more" @click.prevent="scrollToTop">자세히 보기</a>
                    </li>
                    <li>
                        <div class="tags">
                            <span>제휴병원</span>
                            <span>EMR</span>
                        </div>
                        <strong class="product-name">솔닥파트너스</strong>
                        <p>솔닥 제휴 의료진에게만 제공되는<br> 특별한 혜택을 경험하고 앞서나가는<br> 의료 서비스를 제공하세요</p>
                        <a href="https://soldoc.co.kr/partners" class="more" target="_blank" title="새 창">자세히 보기</a>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'CompanyIntro',
    methods: {
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            }, 5);
        }
    },    
    directives: {
        intersect: {
            // 요소가 DOM에 삽입될 때 호출됩니다.
            inserted(el) {
                const options = {
                    root: null, // 뷰포트를 기본값으로 설정
                    rootMargin: '0px', // 뷰포트의 마진은 0
                    threshold: 0.1 // 10%가 보일 때 콜백이 실행
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            el.classList.add('visible');
                        } else {
                            el.classList.remove('visible');
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el); // 해당 요소를 관찰 시작
            }
        }
    },
}
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare_new/CompanyIntro.vue